/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Created_LabelInputs */

const en_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const fr_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree`)
};

const de_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

const it_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato`)
};

const ru_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Созданный`)
};

const es_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

const zh_cn2_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建`)
};

const ja_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

const hi_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाया था`)
};

const pt_pt2_manual_qc_created_label = /** @type {(inputs: Manual_Qc_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Manual_Qc_Created_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_created_label = /** @type {((inputs?: Manual_Qc_Created_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Created_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_created_label(inputs)
	if (locale === "de") return de_manual_qc_created_label(inputs)
	if (locale === "it") return it_manual_qc_created_label(inputs)
	if (locale === "ru") return ru_manual_qc_created_label(inputs)
	if (locale === "es") return es_manual_qc_created_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_created_label(inputs)
	if (locale === "ja") return ja_manual_qc_created_label(inputs)
	if (locale === "hi") return hi_manual_qc_created_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_created_label(inputs)
	return en_manual_qc_created_label(inputs)
});